export default __webpack_public_path__ + "static/media/logo.9c03f385.svg";